var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 28,
    viewBox: "0 0 29 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 29,
    height: 28,
    rx: 8,
    fill: "#F40000"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0625 6V6.83333H8V8.5H8.8125V19.3333C8.8125 19.7754 8.9837 20.1993 9.28845 20.5118C9.5932 20.8244 10.0065 21 10.4375 21H18.5625C18.9935 21 19.4068 20.8244 19.7115 20.5118C20.0163 20.1993 20.1875 19.7754 20.1875 19.3333V8.5H21V6.83333H16.9375V6H12.0625ZM10.4375 8.5H18.5625V19.3333H10.4375V8.5ZM12.0625 10.1667V17.6667H13.6875V10.1667H12.0625ZM15.3125 10.1667V17.6667H16.9375V10.1667H15.3125Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.d6393a7aebf040938ceee94fd0fa2493.svg";
export { ForwardRef as ReactComponent };